'use strict';

import {Component, Inject, OnInit} from 'ng-metadata/core';
import {PrimolyticsService} from '../../analytics/primolytics.service';
import {getBackendSystem, getChosenKeepMeSignInConf, getSessionTimeoutParams, getKeepMeSignInConfig} from '../../appConfig/appConfigForward';
import {SharedSessionStorage} from "../../infra/sharedSessionStorage.service";
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import {UserSessionManagerService} from "../userSessionManager.service";
import { PopupMessageService } from './popupMessage.service';

@Component({
    selector: 'prm-popup-message',
    templateUrl: 'components/security/popupMessage/popup-message.html',
})


export class PrmPopupMessage implements OnInit {

    private chosenConf = getChosenKeepMeSignInConf();
    private MAX_TIMEOUT_SESSION: number = 604800; // 7 days in seconds = 604800
    private AUTO_EXTEND_MY_SESSION: string = 'autoExtendMySession';
    private DISPLAY_USER_SETTINGS: string = 'display_user_settings';

    constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('SessionTimeoutService') private sessionTimeoutService,
                @Inject('$element') private $element: ng.IRootElementService,
                private popupMessageService: PopupMessageService,
                private primolyticsService: PrimolyticsService,
                private sharedSessionStorage: SharedSessionStorage,
                private userSessionManagerService: UserSessionManagerService,
                private mappingTablesCache: MappingTablesCache) {
    }

    // 'Yes, keep me signed in' button pressed
    public confirmPopupMessage() {
        this.hidePopupMessage();
        this.sendBriefBeacon('extendSession');

        // Extend the session for predefined maximum period of time OR
        // Extend the session for another (same) session period
        let extendTime = this.chosenConf == 'extend_max' || (this.autoExtendSessionEnabledByUser() && this.isAutoExtendMySessionEnabledByInst()) ? this.MAX_TIMEOUT_SESSION : getSessionTimeoutParams().userSessionTimeout * 60;

        // For Primo & Primo VE : update the session period in client
        this.sessionTimeoutService.updateSessionTimeoutTime(extendTime);

        // For primo : update the session period also in server
        if(getBackendSystem() !== 'suprima'){
           this.callPrimoServer(extendTime);
        }

    }

    // 'No, sign me out' button pressed
    public closePopupMessage() { 
        this.hidePopupMessage();
        this.userSessionManagerService.logout(true);
    }

    private hidePopupMessage() {
        let dialog = this.$element[0].querySelector('#popupDialog') as HTMLDialogElement;
        dialog.close();
    }

    public callPrimoServer(extendTime){
        this.popupMessageService.callPrimoServer(extendTime);
    }

    // To keep focus inside the Dialog
    public keyDownSupportGoToFirstButton(e) {
        let sendBtn = document.getElementById('popupMessageConfirmBtn');
        if (sendBtn && e.keyCode === 9) {
            e.preventDefault();
            sendBtn.focus();
        }
    }

    public sendBriefBeacon(currOp) {
        this.primolyticsService.doBeaconReport({
            'p': 'general',
            'op': currOp
        }, this.item, this.primolyticsService.getTimestamp());
    }

    private autoExtendSessionEnabledByUser(): boolean{
        return this.sharedSessionStorage.getItem(this.AUTO_EXTEND_MY_SESSION) === 'true';
    }

    private isAutoExtendMySessionEnabledByInst() {
        return this.showUserSetting ? this.showAutoExtendMySessionToggle(): false;
    }

    private showUserSetting() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DISPLAY_USER_SETTINGS }).length > 0;
    }

    private showAutoExtendMySessionToggle() {
        return getKeepMeSignInConfig().isEnableUserSettingForExtendSession;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/popupMessage/popupMessage.directive.ts